import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class CustomDateAdapter extends NgbDateAdapter<moment.Moment> {
  fromModel(value: moment.Moment | null): NgbDateStruct | null {
    if (!value || !moment.isMoment(value)) {
      return null;
    }
    return {
      year: value?.year(),
      month: value?.month() + 1,
      day: value?.date(),
    };
  }

  toModel(date: NgbDateStruct | null): moment.Moment | null {
    if (
      !date ||
      typeof date !== 'object' ||
      !date?.year ||
      !date?.month ||
      !date?.day
    ) {
      return null;
    }
    return moment([date.year, date.month - 1, date.day]);
  }
}
